import { createMasonryEngineNodeRenderersRegistry } from '@leagueplatform/masonry-engine';
import { MasonryDriverNode } from '@leagueplatform/masonry-renderers';
import { MasonrySpinnerNode } from '#components/spinner/spinner.component.tsx';
import { MasonryDriverDefaultNodeRendererMap } from './masonry-default-node-renderers-map';

export type MasonryDriverRegistryNode = MasonryDriverNode | MasonrySpinnerNode;

export const MasonryDriverNodeRenderersRegistry =
  createMasonryEngineNodeRenderersRegistry<MasonryDriverRegistryNode>(
    MasonryDriverDefaultNodeRendererMap,
  );
